import React from 'react';

/**
 * <SegControl options={[7, 14, 30]} value={range} onChange={setRange} suffix="d" />
 *
 * Segmented pill control for small range/window switches.
 * Visuals live in _components.scss (.sh-seg).
 */
export default function SegControl({ options, value, onChange, suffix, format, ariaLabel }) {
  return (
    <div className="sh-seg" role="group" aria-label={ariaLabel}>
      {options.map(o => {
        const active = o === value;
        return (
          <button
            key={o}
            type="button"
            onClick={() => onChange(o)}
            aria-pressed={active}
            className={`sh-seg-btn${active ? ' is-active' : ''}`}
          >
            {format ? format(o) : o}
            {suffix && active ? <span className="sh-seg-suffix">{suffix}</span> : ''}
          </button>
        );
      })}
    </div>
  );
}
